import React, { useState } from 'react';
import { Search, Filter, Plus, Building2, Camera, ClipboardList, Clock, AlertCircle, CheckCircle, AlertTriangle, ArrowRight, ChevronDown, Calendar, Loader2, Edit2, User, ChevronRight } from 'lucide-react';
import { NewEsigenzaModal } from './modals/NewEsigenzaModal';
type Status = 'In Creazione' | 'In Attesa' | 'Programmata' | 'Completata';
type UrgencyLevel = 'Bassa' | 'Media' | 'Alta';
type ImpactLevel = 'Basso' | 'Medio' | 'Alto';
interface Esigenza {
  id: number;
  title: string;
  property: string;
  address: string;
  status: Status;
  urgency: UrgencyLevel;
  urgencyText: string;
  impact: ImpactLevel;
  impactText?: string;
  checklistCount: number;
  photoCount: number;
  createdAt: string;
  // Specific fields based on status
  progress?: {
    current: number;
    total: number;
  }; // For 'In Creazione'
  requestSentDate?: string; // For 'In Attesa'
  fornitore?: {
    name: string;
    initials: string;
    avatarColor: string;
  };
  intervento?: {
    date: string;
    timeStart: string;
    timeEnd: string;
  };
  completedAt?: string;
}
const mockEsigenze: Esigenza[] = [{
  id: 1,
  title: 'Pulizia post check-out urgente',
  property: 'Appartamento Prati',
  address: 'Via Cola di Rienzo 28',
  status: 'Programmata',
  urgency: 'Alta',
  urgencyText: 'Check-in tra 3 ore',
  impact: 'Alto',
  fornitore: {
    name: 'Sofia Bianchi',
    initials: 'SB',
    avatarColor: 'bg-teal-100 text-teal-700'
  },
  intervento: {
    date: '09 Feb',
    timeStart: '12:00',
    timeEnd: '14:00'
  },
  checklistCount: 5,
  photoCount: 2,
  createdAt: 'Oggi, 09:30'
}, {
  id: 2,
  title: 'Sanificazione post-infestazione',
  property: 'Suite Testaccio',
  address: 'Via Marmorata 32',
  status: 'In Attesa',
  urgency: 'Alta',
  urgencyText: 'Check-in domani mattina',
  impact: 'Alto',
  checklistCount: 6,
  photoCount: 4,
  requestSentDate: 'Oggi',
  createdAt: 'Oggi, 08:00'
}, {
  id: 3,
  title: 'Pulizia ordinaria programmata',
  property: 'Loft Centro Storico',
  address: 'Via del Corso 150',
  status: 'Programmata',
  urgency: 'Media',
  urgencyText: 'Check-in tra 4 giorni',
  impact: 'Medio',
  fornitore: {
    name: 'Marco R.',
    initials: 'MR',
    avatarColor: 'bg-blue-100 text-blue-700'
  },
  intervento: {
    date: '14 Feb',
    timeStart: '10:00',
    timeEnd: '12:30'
  },
  checklistCount: 5,
  photoCount: 3,
  createdAt: 'Ieri, 14:15'
}, {
  id: 4,
  title: 'Cambio biancheria e rifornimento',
  property: 'Loft Centro Storico',
  address: 'Via del Corso 150',
  status: 'In Attesa',
  urgency: 'Media',
  urgencyText: 'Check-in tra 6 giorni',
  impact: 'Basso',
  checklistCount: 4,
  photoCount: 0,
  requestSentDate: '2 giorni fa',
  createdAt: '3 giorni fa'
}, {
  id: 5,
  title: 'Riparazione e pulizia bagno',
  property: 'Bilocale Trastevere',
  address: 'Via della Lungaretta 12',
  status: 'In Creazione',
  urgency: 'Bassa',
  urgencyText: 'Nessuna deadline',
  impact: 'Basso',
  progress: {
    current: 3,
    total: 5
  },
  checklistCount: 0,
  photoCount: 1,
  createdAt: '2 giorni fa'
}, {
  id: 6,
  title: 'Pulizia profonda trimestrale',
  property: 'Appartamento Prati',
  address: 'Via Cola di Rienzo 28',
  status: 'Completata',
  urgency: 'Bassa',
  urgencyText: 'Nessuna deadline',
  impact: 'Basso',
  fornitore: {
    name: 'Lucia M.',
    initials: 'LM',
    avatarColor: 'bg-pink-100 text-pink-700'
  },
  intervento: {
    date: '05 Feb',
    timeStart: '09:00',
    timeEnd: '12:00'
  },
  completedAt: '05 Feb',
  checklistCount: 5,
  photoCount: 2,
  createdAt: '01 Feb'
}];
export function HostEsigenzePage() {
  const [activeTab, setActiveTab] = useState<'Tutte' | 'In Creazione' | 'In Attesa' | 'Programmate' | 'Completate'>('Tutte');
  const [searchQuery, setSearchQuery] = useState('');
  const [showNewEsigenzaModal, setShowNewEsigenzaModal] = useState(false);
  // Properties list for the modal
  const properties = [{
    id: 1,
    name: 'Appartamento Prati',
    address: 'Via Cola di Rienzo 28'
  }, {
    id: 2,
    name: 'Suite Testaccio',
    address: 'Via Marmorata 32'
  }, {
    id: 3,
    name: 'Loft Centro Storico',
    address: 'Via del Corso 150'
  }, {
    id: 4,
    name: 'Bilocale Trastevere',
    address: 'Via della Lungaretta 12'
  }];
  const handleCreateEsigenza = (esigenza: any) => {
    console.log('Nuova esigenza creata:', esigenza);
    alert('Esigenza creata con successo!');
    setShowNewEsigenzaModal(false);
  };
  const filteredEsigenze = mockEsigenze.filter(item => {
    // Filter by Tab
    if (activeTab !== 'Tutte' && item.status !== activeTab) {
      // Map tab names to status if they differ slightly, but here they match mostly
      // 'Programmate' maps to 'Programmata'
      if (activeTab === 'Programmate' && item.status === 'Programmata') {
        // match
      } else if (activeTab === 'Completate' && item.status === 'Completata') {
        // match
      } else if (item.status === activeTab) {
        // match
      } else {
        return false;
      }
    }
    // Filter by Search
    if (searchQuery) {
      const query = searchQuery.toLowerCase();
      return item.title.toLowerCase().includes(query) || item.property.toLowerCase().includes(query) || item.address.toLowerCase().includes(query);
    }
    return true;
  });
  const getStatusBadge = (status: Status) => {
    switch (status) {
      case 'In Creazione':
        return <span className="inline-flex items-center gap-1 px-2.5 py-1 lg:px-2 lg:py-0.5 rounded-full text-xs lg:text-[10px] font-bold uppercase tracking-wider bg-gray-100 text-gray-600 border border-gray-200" data-id="element-442">
            <Edit2 size={10} data-id="element-443" />
            In Creazione
          </span>;
      case 'In Attesa':
        return <span className="inline-flex items-center gap-1 px-2.5 py-1 lg:px-2 lg:py-0.5 rounded-full text-xs lg:text-[10px] font-bold uppercase tracking-wider bg-amber-50 text-amber-700 border border-amber-100" data-id="element-444">
            <Clock size={10} data-id="element-445" />
            In Attesa
          </span>;
      case 'Programmata':
        return <span className="inline-flex items-center gap-1 px-2.5 py-1 lg:px-2 lg:py-0.5 rounded-full text-xs lg:text-[10px] font-bold uppercase tracking-wider bg-blue-50 text-blue-700 border border-blue-100" data-id="element-446">
            <Calendar size={10} data-id="element-447" />
            Programmata
          </span>;
      case 'Completata':
        return <span className="inline-flex items-center gap-1 px-2.5 py-1 lg:px-2 lg:py-0.5 rounded-full text-xs lg:text-[10px] font-bold uppercase tracking-wider bg-green-50 text-green-700 border border-green-100" data-id="element-448">
            <CheckCircle size={10} data-id="element-449" />
            Completata
          </span>;
    }
  };
  const getUrgencyBadge = (level: UrgencyLevel, text: string) => {
    let colorClass = '';
    let icon = <Clock size={10} data-id="element-450" />;
    switch (level) {
      case 'Alta':
        colorClass = 'bg-red-50 text-red-700 border-red-100';
        icon = <AlertCircle size={10} data-id="element-451" />;
        break;
      case 'Media':
        colorClass = 'bg-amber-50 text-amber-700 border-amber-100';
        break;
      case 'Bassa':
        colorClass = 'bg-blue-50 text-blue-700 border-blue-100';
        break;
    }
    return <span className={`inline-flex items-center gap-1 px-2.5 py-1 lg:px-2 lg:py-0.5 rounded-full text-xs lg:text-[10px] font-medium border ${colorClass}`} data-id="element-452">
        {icon}
        {level} - {text}
      </span>;
  };
  const getImpactBadge = (level: ImpactLevel) => {
    let colorClass = '';
    switch (level) {
      case 'Alto':
        colorClass = 'bg-red-50 text-red-700 border-red-100';
        break;
      case 'Medio':
        colorClass = 'bg-amber-50 text-amber-700 border-amber-100';
        break;
      case 'Basso':
        colorClass = 'bg-blue-50 text-blue-700 border-blue-100';
        break;
    }
    return <span className={`inline-flex items-center gap-1 px-2.5 py-1 lg:px-2 lg:py-0.5 rounded-full text-xs lg:text-[10px] font-medium border ${colorClass}`} data-id="element-453">
        <AlertTriangle size={10} data-id="element-454" />
        Impatto {level}
      </span>;
  };
  const getCardBorderClass = (status: Status) => {
    switch (status) {
      case 'In Creazione':
        return 'bg-gray-50/30';
      case 'In Attesa':
        return '';
      case 'Programmata':
        return '';
      case 'Completata':
        return 'opacity-90';
    }
  };
  return <div className="animate-in fade-in slide-in-from-bottom-4 duration-500 space-y-6" data-id="element-455">
      {/* Header */}
      <div className="flex flex-col sm:flex-row sm:items-start justify-between gap-4" data-id="element-456">
        <div data-id="element-457">
          <h1 className="text-2xl lg:text-2xl font-bold font-montserrat text-navy mb-1" data-id="element-458">
            Esigenze
          </h1>
          <p className="text-sm text-gray-500" data-id="element-459">
            Gestisci e monitora le esigenze delle tue proprietà
          </p>
        </div>
        <button onClick={() => setShowNewEsigenzaModal(true)} className="flex items-center gap-2 bg-teal-deep text-white rounded-lg hover:bg-teal-deep/90 font-medium text-sm px-5 py-3 lg:px-4 lg:py-2.5 transition-colors shadow-sm whitespace-nowrap min-h-[48px] lg:min-h-[44px]" data-id="element-460">
          <Plus size={18} data-id="element-461" />
          <span data-id="element-462">Nuova Esigenza</span>
        </button>
      </div>

      {/* Summary Stats Row */}

      {/* Tabs & Filters */}
      <div className="flex flex-col gap-4" data-id="element-463">
        {/* Horizontal Tabs */}
        <div className="border-b border-gray-200 flex gap-4 lg:gap-6 overflow-x-auto" data-id="element-464">
          {[{
          id: 'Tutte',
          label: 'Tutte',
          count: 6
        }, {
          id: 'In Creazione',
          label: 'In Creazione',
          count: 1
        }, {
          id: 'In Attesa',
          label: 'In Attesa',
          count: 2
        }, {
          id: 'Programmate',
          label: 'Programmate',
          count: 2
        }, {
          id: 'Completate',
          label: 'Completate',
          count: 1
        }].map(tab => <button key={tab.id} onClick={() => setActiveTab(tab.id as any)} className={`pb-3 text-sm font-medium border-b-2 transition-colors whitespace-nowrap flex items-center gap-2 ${activeTab === tab.id ? 'border-teal-deep text-teal-deep' : 'border-transparent text-gray-500 hover:text-gray-700'}`} data-id="element-465">
              {tab.label}
              <span className={`text-xs lg:text-[10px] px-1.5 py-0.5 rounded-full ${activeTab === tab.id ? 'bg-teal-100 text-teal-700' : 'bg-gray-100 text-gray-500'}`} data-id="element-466">
                {tab.count}
              </span>
            </button>)}
        </div>

        {/* Filter Row */}
        <div className="flex flex-col md:flex-row gap-3 items-center justify-between" data-id="element-467">
          <div className="relative w-full md:w-80" data-id="element-468">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 w-4 h-4" data-id="element-469" />
            <input type="text" placeholder="Cerca per titolo o proprietà..." value={searchQuery} onChange={e => setSearchQuery(e.target.value)} className="w-full pl-10 pr-4 py-3 lg:py-2 border border-gray-200 rounded-lg text-sm focus:ring-2 focus:ring-teal-deep focus:border-transparent outline-none min-h-[48px] lg:min-h-[40px]" data-id="element-470" />
          </div>
          <div className="flex gap-3 w-full md:w-auto" data-id="element-471">
            <button className="flex-1 md:flex-none flex items-center justify-center gap-2 px-4 py-3 lg:py-2 border border-gray-200 rounded-lg text-sm text-gray-600 hover:bg-gray-50 hover:text-navy transition-colors bg-white min-h-[48px] lg:min-h-[40px]" data-id="element-472">
              <Filter size={16} data-id="element-473" />
              <span data-id="element-474">Filtra</span>
              <ChevronDown size={14} className="text-gray-400" data-id="element-475" />
            </button>
          </div>
        </div>
      </div>

      {/* Esigenze List */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4" data-id="element-476">
        {filteredEsigenze.length > 0 ? filteredEsigenze.map(item => <div key={item.id} className="group relative bg-white border border-gray-200 rounded-xl p-5 hover:shadow-sm transition-all cursor-pointer" data-id="element-477">
              {/* Top Row: Status + Urgency (if High) */}
              <div className="flex justify-between items-center mb-3" data-id="element-478">
                {getStatusBadge(item.status)}
                {item.urgency === 'Alta' && <span className="text-[10px] font-bold text-red-600 bg-red-50 px-2 py-0.5 rounded-full border border-red-100 flex items-center gap-1" data-id="element-479">
                    <AlertCircle size={10} data-id="element-480" />
                    Urgente
                  </span>}
              </div>

              {/* Title & Property */}
              <h3 className="text-base font-semibold text-navy mb-1 pr-8" data-id="element-481">
                {item.title}
              </h3>
              <p className="text-sm text-gray-500 mb-5" data-id="element-482">{item.property}</p>

              {/* Dynamic Footer Content */}
              <div className="min-h-[24px] flex items-center" data-id="element-483">
                {item.status === 'In Creazione' && item.progress && <div className="w-full max-w-[140px]" data-id="element-484">
                    <div className="flex justify-between text-[10px] text-gray-400 mb-1" data-id="element-485">
                      <span data-id="element-486">Completamento</span>
                      <span data-id="element-487">
                        {Math.round(item.progress.current / item.progress.total * 100)}
                        %
                      </span>
                    </div>
                    <div className="w-full bg-gray-100 rounded-full h-1.5" data-id="element-488">
                      <div className="bg-teal-deep h-1.5 rounded-full" style={{
                width: `${item.progress.current / item.progress.total * 100}%`
              }} data-id="element-489"></div>
                    </div>
                  </div>}

                {item.status === 'In Attesa' && <span className="text-xs text-gray-400 italic flex items-center gap-1.5" data-id="element-490">
                    <Clock size={12} data-id="element-491" />
                    Richiesta inviata {item.requestSentDate}
                  </span>}

                {(item.status === 'Programmata' || item.status === 'Completata') && item.fornitore && <div className="flex items-center gap-2" data-id="element-492">
                      <div className={`w-5 h-5 rounded-full flex items-center justify-center text-[9px] font-bold ${item.fornitore.avatarColor}`} data-id="element-493">
                        {item.fornitore.initials}
                      </div>
                      <span className="text-xs text-gray-600 font-medium" data-id="element-494">
                        {item.fornitore.name}
                      </span>
                      {item.intervento && <span className="text-xs text-gray-400" data-id="element-495">
                          · {item.intervento.date}
                        </span>}
                    </div>}
              </div>

              {/* Navigation Hint */}
              <div className="absolute top-1/2 right-4 -translate-y-1/2 text-gray-300 group-hover:text-teal-deep transition-colors" data-id="element-496">
                <ChevronRight size={20} data-id="element-497" />
              </div>
            </div>) : <div className="col-span-full text-center py-12 bg-white rounded-xl border border-gray-200 border-dashed" data-id="element-498">
            <div className="w-12 h-12 bg-gray-50 rounded-full flex items-center justify-center mx-auto mb-3" data-id="element-499">
              <Search className="text-gray-400" data-id="element-500" />
            </div>
            <h3 className="text-base lg:text-sm font-bold text-navy mb-1" data-id="element-501">
              Nessuna esigenza trovata
            </h3>
            <p className="text-sm lg:text-xs text-gray-500" data-id="element-502">
              Prova a modificare i filtri di ricerca
            </p>
          </div>}
      </div>

      <NewEsigenzaModal isOpen={showNewEsigenzaModal} onClose={() => setShowNewEsigenzaModal(false)} onSave={handleCreateEsigenza} properties={properties} preSelectedPropertyId={null} data-id="element-503" />
    </div>;
}